import { createContext } from 'react';
export const BoundaryElementContext = createContext(null);
//# sourceMappingURL=boundaryElementContext.js.map